import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { ImageCarousel } from '@common/components/ImageCarousel';
import { BackgroundImgixWrapper } from '@common/components';
import { HurryMessage } from '@common/components/HurryMessage';
import { CarouselRightIcon, CarouselLeftIcon } from '@root/styles/icons';
import { DiscountBanner } from '../Price';
import {
  HeaderWrapper,
  HeaderTexts,
  Title,
  Imagewrapper,
  InnerWrap,
  PriceInfoWrapper,
  StyledPrice,
  Duration,
  DurationMobile,
  InfoWrapper,
  PriceLabel,
  HurryMessageWrapper,
} from './DetailsPageHeader.styles';
import { ComponentProps } from './DetailsPageHeader.types';
import { spaces } from '../../theme/spaces';
import { some } from '@utils/some';

export const DetailsPageHeader: FC<ComponentProps> = (props) => {
  const { t } = useTranslations();
  const { name, metadata = null, imgixParams, hidePrice } = props;
  const { duration }: any = metadata;
  let { image = null, images = null } = props;
  if (images && images.length === 1) {
    [image] = images;
    images = null;
  }

  const leftButton = <CarouselLeftIcon width="40" height="40" />;
  const rightButton = <CarouselRightIcon width="40" height="40" />;

  return (
    <HeaderWrapper>
      <InnerWrap>
        {image && (
          <Imagewrapper>
            <BackgroundImgixWrapper src={image.url} baseParams={imgixParams} isFullDim />
          </Imagewrapper>
        )}
        {images && some(images) && (
          <ImageCarousel
            carouselOptions={{
              play: true,
              interval: 6000,
              buttonContentLeft: leftButton,
              buttonContentRight: rightButton,
              organicArrows: false,
            }}
            images={images}
          />
        )}

        <HeaderTexts>
          <DiscountBanner discount={metadata?.discount} margin={spaces.space5} />
          <InfoWrapper>
            {duration && (
              <DurationMobile>
                <p>{t('spa.durationIndicator')}</p>
                {Number.isInteger(duration)
                  ? t('spa.minutesIndicator', { number: duration })
                  : t(duration)}
              </DurationMobile>
            )}
            {!hidePrice && (
              <PriceInfoWrapper>
                <div>
                  <PriceLabel>{t('spa.priceLabel')}</PriceLabel>
                  {metadata?.price ? (
                    <>
                      {t('common.from')}{' '}
                      <StyledPrice {...metadata} numberOfGuests={metadata.guests} />
                    </>
                  ) : (
                    <>{t('room.priceUnavailable')}</>
                  )}
                </div>

                {metadata?.displayUrgencyMessaging && metadata?.quantity && (
                  <HurryMessageWrapper>
                    <HurryMessage quantity={metadata.quantity} />
                  </HurryMessageWrapper>
                )}
              </PriceInfoWrapper>
            )}
          </InfoWrapper>
          <Title>{name}</Title>
          {duration && (
            <Duration>
              {Number.isInteger(duration)
                ? t('spa.minutesIndicator', { number: duration })
                : t(duration)}
            </Duration>
          )}
        </HeaderTexts>
      </InnerWrap>
    </HeaderWrapper>
  );
};
